module.exports = __webpack_public_path__ + "img/xmy.605b8898.svg";